

























import {Component, Prop, Provide, Vue} from "vue-property-decorator";
import { ticketClient } from "@/api";
import { SuspendTicketReq } from "@/pbjs/xcommon/ticket_pb";
import { setMetaData, dateFormat } from "@/utils";
import { setCommon, errorMsg } from "@/utils/request";
@Component({
    name: "StopCollectionModal",
})
export default class StopCollectionModal extends Vue {
    @Prop() stopRowData!: any;
    @Prop() showPopDialog!: Function;
    @Prop() getTicketList!: Function;
    @Prop() stopType!: string; //判断:停催--stop，取消停催--cancel
    @Provide() private dateValue: any = '';
    @Provide() private timestamp: any = this.stopRowData.suspendtime ? dateFormat(this.stopRowData.suspendtime) : '';
    @Provide() private pickerOptions: object = {
        disabledDate(time:any) {
            return time.getTime() < Date.now();
        },
    }
    private closePopDialog() {
        this.$emit("showPopDialog", false);
    }
    private submit() {
        let ticketId = this.stopRowData.id;
        let itemId = this.stopRowData.itemid;
        if(this.stopType === 'stop') {
            let request: any = new SuspendTicketReq();
            request.setCommonin(setCommon());
            request.setItemid(itemId);
            request.setTicketid(ticketId);
            request.setSuspendtime(this.dateValue);
            ticketClient.suspendTicket(request, setMetaData(), (err: any, response: any) => {
                if (response) {
                    let data: any = response.toObject();
                    if (!data.commonout || (data.commonout.code == 0)) {
                        this.$message({
                            message: this.$tc("tipsWrh.opreSuccess"),
                            type: "success",
                        });
                        this.$emit("getTicketList");
                        this.$emit("showPopDialog", false);
                    } else {
                        this.$message.error(data.commonout.errmsg);
                    }
                }
                if (err) {
                    errorMsg(err);
                }
            });
        }
        if(this.stopType === 'cancel') {
            let request: any = new SuspendTicketReq();
            request.setCommonin(setCommon());
            request.setItemid(itemId);
            request.setTicketid(ticketId);
            request.setSuspendtime(this.timestamp);
            ticketClient.unSuspendTicket(request, setMetaData(), (err: any, response: any) => {
                if (response) {
                    let data: any = response.toObject();
                    if (!data.commonout || (data.commonout.code == 0)) {
                        this.$message({
                            message: this.$tc("tipsWrh.opreSuccess"),
                            type: "success",
                        });
                        this.$emit("getTicketList");
                        this.$emit("showPopDialog", false);
                    } else {
                        this.$message.error(data.commonout.errmsg);
                    }
                }
                if (err) {
                    errorMsg(err);
                }
            });
        }
    }   
}
